import { createDirectedGraph } from './directedGraph';
export const serialize = graph => {
  const nodes = [];
  const edges = [];
  for (const [id, data] of graph.node.entries()) {
    nodes.push({
      id,
      data
    });
  }
  for (const [sourceId, targets] of graph.edge.getAllOutgoing()) {
    for (const targetId of targets) {
      const metadata = graph.edge.metadata.get(sourceId, targetId);
      edges.push({
        sourceId,
        targetId,
        metadata
      });
    }
  }
  return {
    nodes,
    edges
  };
};
export const deserialize = serialized => {
  const graph = createDirectedGraph();
  for (const {
    id,
    data
  } of serialized.nodes) {
    graph.node.set(id, data);
  }
  for (const {
    sourceId,
    targetId,
    metadata
  } of serialized.edges) {
    graph.edge.add(sourceId, targetId, metadata);
  }
  return graph;
};